export const OPERATION_MODULE_MAP = [
	{ value : 1, type : 'system', cn : '系统'},
	{ value : 2, type : 'keywordMonitoring', cn : '关键词监控'},
	{ value : 3, type : 'brandAnalysis', cn : '品牌分析(ABA)'},
	{ value : 4, type : 'trafficSource', cn : '查流量来源'},
	{ value : 4, type : 'reverseSearch', cn : '反查流量词'},
	{ value : 5, type : 'user', cn : '用户'},
]

export function getOperationModuleCnByType(type){
	let o = OPERATION_MODULE_MAP.find(i => i.type === type)
	if (o){
		return o.cn
	}
}
